<div class="page-wrap h-full slate">
    <div class="session-form-hold">
      <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
      <mat-card>
        <mat-card-content>
          <div class="text-center pt-8 pb-16">
            <img  width="100%" src="assets/images/logo-blanco.png" alt="" class="mb-8">
            <p class="text-muted m-0">El correo electrónico ha sido enviado con éxito, use el pin que le enviamos por correo para restablecer su contraseña</p>
          </div>
          <form [formGroup]="form" (ngSubmit)="submit()">
  
            <div class="">
              <mat-form-field class="full-width">
                <input
                  matInput
                  name="pin"
                  formControlName="pin"
                  placeholder="Pin"
                  value="">
              </mat-form-field>

              <mat-form-field class="full-width">
                <input
                  matInput
                  name="newPassword"
                  formControlName="newPassword"
                  placeholder="Password"
                  value="">
              </mat-form-field>

              <mat-form-field class="full-width">
                <input
                  matInput
                  name="newPasswordConfirm" 
                  formControlName="newPasswordConfirm" 
                  placeholder="Password confirm"
                  value="">
                  
              </mat-form-field>
              
            </div>
  
            <button mat-raised-button class="mat-primary full-width mb-16" [disabled]="!form.valid">Submit</button>
            <div class="text-center">
              <a [routerLink]="'/sessions/signin'" class="mat-primary text-center full-width">Sign in</a>
              <span fxFlex></span>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  
  
